export default "__VITE_ASSET__DQ7woa74__"